import ScrollAnime from "./common/anime/scroll";

document.addEventListener("DOMContentLoaded", () => {
    const scroll = new ScrollAnime();
});
